module.exports = __webpack_public_path__ + "static/media/[Performance]2010-07-18-3.461af168.md";